var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPleatAdmin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 172,
    height: 33,
    viewBox: "0 0 172 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69.3512 9.14512C68.784 8.48134 68.0818 7.94605 67.2914 7.57492C66.4289 7.1792 65.4882 6.98299 64.5394 7.00088H55V30.0642H57.1611V21.3521H64.5394C65.4882 21.37 66.4289 21.1738 67.2914 20.7781C68.0818 20.4069 68.784 19.8717 69.3512 19.2079C69.915 18.5331 70.35 17.7605 70.6344 16.9286C70.9278 16.0408 71.076 15.1115 71.0734 14.1765C71.0745 13.2471 70.9263 12.3237 70.6344 11.4413C70.3501 10.6042 69.9152 9.826 69.3512 9.14512ZM57.1611 7.89572H63.6614C64.4313 7.87841 65.1927 8.0586 65.8732 8.41911C66.4937 8.77177 67.0296 9.25582 67.4434 9.83736C67.8753 10.4518 68.1954 11.1377 68.3889 11.8634C68.6042 12.6155 68.7122 13.3942 68.7097 14.1765C68.7134 14.9533 68.6053 15.7266 68.3889 16.4727C68.1952 17.1931 67.8751 17.8734 67.4434 18.4819C67.0343 19.0676 66.4974 19.5526 65.8732 19.9001C65.1948 20.2679 64.4329 20.454 63.6614 20.4404H57.1274L57.1611 7.89572Z",
    fill: "#A5352F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M84.3775 7.00098H82.2164V30.0643H95.3351V29.1525H84.3775V7.00098Z",
    fill: "#A5352F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M105.432 30.0643H118.55V29.1525H107.593V17.8066H117.453V16.878H107.593V7.87893H118.55V7.00098H105.432V30.0643Z",
    fill: "#A5352F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M136.448 7.00098L127.398 30.0643H128.36L130.673 24.138H142.289L144.602 30.0643H146.831L137.748 7.00098H136.448ZM131.045 23.2432L136.464 9.3647L141.918 23.2432H131.045Z",
    fill: "#A5352F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M153.685 7.00098V7.87893H161.317V30.0643H163.512V7.87893H171.143V7.00098H153.685Z",
    fill: "#A5352F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1426 0.594022V32.9999H22.4615V0.498291L32.1426 0.594022Z",
    fill: "#A5352F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6926 32.9999H17.831C18.6206 22.1701 18.6686 11.2988 17.9746 0.462402H20.0448C20.3321 11.3264 19.8803 22.1973 18.6926 32.9999Z",
    fill: "#A5352F"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7588 0.462406C17.0539 11.3919 15.6187 22.262 13.4627 32.9999H12.6849C14.4176 22.2258 15.4251 11.3476 15.7005 0.438477L17.7588 0.462406Z",
    fill: "#A5352F"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0664 0.437997C13.5225 11.4378 11.2194 22.3176 8.17355 32.9995H7.51538C10.0969 22.2765 11.9401 11.3892 13.032 0.414062L15.0664 0.437997Z",
    fill: "#A5352F"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0864 0.414559C9.6659 11.5628 6.24141 22.4691 1.85485 33H0C4.43989 22.4694 7.90479 11.5539 10.3512 0.390625L12.0864 0.414559Z",
    fill: "#A5352F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPleatAdmin);
export default __webpack_public_path__ + "static/media/pleat_admin.5016f51f14e380736185542bc9beebb0.svg";
export { ForwardRef as ReactComponent };